<script setup lang="ts">
import AppButton from '~/components/AppButton.vue'
import CmsLink from '~/layers/cms/app/components/cms/CmsLink.vue'
import type { CmsCustomComponentType } from '~/layers/cms/app/types/cmsTypes'

const props = defineProps<{
  cmsDataPath: (string | number)[]
}>()
const nazwa_komponentu = 'Buttons/Button1'
const component_default_values: CmsCustomComponentType = {
  id: { value: undefined, default_value: 'Lorem Ipsum', settingType: 'text', setting_label: 'zmien id' },
  theme: { value: undefined, selectValues: ['Primary', 'Secondary', 'Transparent-Teksty', 'Background-2'], default_value: 'Primary', settingType: 'select', setting_label: 'zmien theme' },
  arrow: { value: false, default_value: false, settingType: 'boolean', setting_label: 'czy arrow' },
  download: { value: false, default_value: false, settingType: 'boolean', setting_label: 'czy download' }
}
</script>

<template>
  <CmsCustomComponent
    v-slot="{ component_values }"
    :cms-data-path="[...props.cmsDataPath]"
    :component-name="nazwa_komponentu"
    :defaults="component_default_values"
    :open-options="true"
  >
    <CmsLink
      v-slot="{ link }"
      :cms-data-path="[...props.cmsDataPath, 'component_data', 'link']"
      class="w-fit"
    >
      <AppButton
        :button-theme="(component_values.theme?.value as string) ?? 'Primary'"
        :href="link?.href"
        :target="link?.target"
        :arrow="(component_values.arrow?.value as boolean ?? false)"
        :download="(component_values.download?.value as boolean ?? false)"
      >
        <span>{{ link?.link_text ?? 'Lorem ipsum' }}</span>
      </AppButton>
    </CmsLink>
  </CmsCustomComponent>
</template>
